export default __webpack_public_path__ + "static/media/settings-nav.267532c3.svg";